function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "startWithBlank",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M44,12 L44,38 L7,38 L7,12 L44,12 Z M42,14 L9,14 L9,36 L42,36 L42,14 Z",
  id: "Rectangle",
  fill: "#7F7E7E",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(25.025492, 24.801447) rotate(-6.000000) translate(-25.025492, -24.801447) translate(15.525492, 16.301447)",
  fill: "#7F7E7E"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.53192637,12.5237985 C8.04545165,11.8701121 7.67842746,11.3766022 7.19889082,10.7322616 C7.10869584,10.6110259 8.91490813,8.49472268 9.10524266,8.28535092 C9.82090514,7.49783794 10.5999354,6.77276006 11.3691367,6.05261468 C12.9742604,4.55014843 14.6422893,3.13361157 16.348709,1.7796396 C16.656297,1.53548073 16.965157,1.29339869 17.2750577,1.0532637 C17.530957,0.855054972 17.8128741,0.699291733 18.0826496,0.523798482 C18.1203465,0.569489033 18.1579278,0.61504978 18.1956246,0.660740331 C18.0601009,0.90541842 17.9400722,1.16307678 17.7867407,1.39256795 C16.5556949,3.23563649 15.2748105,5.03742777 13.9296334,6.77730316 C12.6493272,8.433326 11.326005,10.326109 9.72643168,11.6053146 C9.33327407,11.9196967 8.92230874,12.2051329 8.53192637,12.5237985",
  id: "Fill-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0.903638077,15.7256005 C2.20081953,15.1564809 2.8525369,14.3075674 3.41270618,13.3358587 C3.78465158,12.6905947 4.25952605,12.0024926 4.89473474,11.5879043 C6.36488207,10.6281948 7.35815387,11.5819608 7.8849306,12.7514877 C7.93833366,12.8697973 7.86466996,13.0439535 7.82264788,13.1857008 C7.14229047,15.4818042 5.37923927,16.507341 2.76761729,16.1110319 C2.19706756,16.0243463 1.63764868,15.8792348 0.903638077,15.7256005",
  id: "Fill-3"
})));

function SvgStartWithBlank(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "startWithBlank") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartWithBlank);
export default __webpack_public_path__ + "static/media/startWithBlank.f0c019ba.svg";
export { ForwardRef as ReactComponent };